import React from "react";
import { Box, Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";

const VARIANT_STYLES = {
  due: {
    accent: "#f59e0b",
    background: "rgba(245, 158, 11, 0.08)",
    border: "rgba(245, 158, 11, 0.25)",
    text: "#92400e",
    icon: AccessTimeRoundedIcon,
  },
  overdue: {
    accent: "#ef4444",
    background: "rgba(239, 68, 68, 0.08)",
    border: "rgba(239, 68, 68, 0.25)",
    text: "#991b1b",
    icon: ErrorRoundedIcon,
  },
};

const sumExpiryCounts = (data = {}) =>
  (data.complianceExpiry || 0) +
  (data.licenseExpiry || 0) +
  (data.insuranceExpiry || 0);

const ExpiryCard = ({ title, data, loaded = true, variant = "due", onClick }) => {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.due;
  const Icon = styles.icon;
  const count = loaded ? sumExpiryCounts(data) : null;

  return (
    <Card
      elevation={0}
      sx={{
        position: "relative",
        borderRadius: "14px",
        backgroundColor: styles.background,
        border: `1px solid ${styles.border}`,
        height: "100%",
        overflow: "hidden",
        transition: "box-shadow 0.2s ease, transform 0.2s ease",
        "&:hover": {
          boxShadow: `0 4px 16px ${styles.accent}26`,
          transform: "translateY(-1px)",
        },
      }}
    >

      <CardActionArea onClick={onClick} sx={{ height: "100%" }}>
        <CardContent sx={{ py: 1, pl: 2.5, pr: 1.75, "&:last-child": { pb: 1 } }}>
          <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1}>
            <Stack spacing={0.5}>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 700,
                  lineHeight: 1.2,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  color: styles.text,
                  opacity: 0.85,
                }}
              >
                {title}
              </Typography>

              {loaded ? (
                <Typography sx={{ fontSize: 18, fontWeight: 800, lineHeight: 1, color: styles.text }}>
                  {count}
                </Typography>
              ) : (
                <Box
                  sx={{
                    width: 28,
                    height: 20,
                    borderRadius: "6px",
                    backgroundColor: `${styles.accent}33`,
                  }}
                />
              )}
            </Stack>

            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: "9px",
                backgroundColor: `${styles.accent}22`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon sx={{ fontSize: 17, color: styles.accent }} />
            </Box>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ExpiryCard;